import { memo, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PH } from '../components/shared';
import { NotifRow, TYPE_LABELS } from '../components/Sidebar';
import { useApp } from '../context/AppContext';
import { markAllRead } from '../services/notifications';

const CATEGORIES = ['all', ...Object.keys(TYPE_LABELS)];

export const PageNotifications = memo(() => {
  const navigate = useNavigate();
  const { user, inbox, unreadCount } = useApp();
  const [tab, setTab]   = useState('all');   // all | unread
  const [cat, setCat]   = useState('all');
  const [query, setQuery] = useState('');

  const rows = useMemo(() => {
    let list = inbox;
    if (tab === 'unread') list = list.filter(r => !r.readAt);
    if (cat !== 'all')    list = list.filter(r => (r.category || 'team') === cat);
    const q = query.trim().toLowerCase();
    if (q) list = list.filter(r =>
      (r.title||'').toLowerCase().includes(q) || (r.body||'').toLowerCase().includes(q));
    return list;
  }, [inbox, tab, cat, query]);

  const counts = useMemo(() => {
    const m = { all: inbox.length };
    for (const r of inbox) {
      const k = r.category || 'team';
      m[k] = (m[k] || 0) + 1;
    }
    return m;
  }, [inbox]);

  return (
    <div className="pg fi">
      <PH
        eyebrow="Platform"
        title="Notification Center"
        sub="All your real-time alerts in one place"
        action={
          unreadCount > 0 ? (
            <button className="btn" onClick={()=>markAllRead(user?.id, inbox).catch(()=>{})}>
              Mark all read ({unreadCount})
            </button>
          ) : null
        }
      />

      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14,flexWrap:"wrap"}}>
        <div style={{display:"flex",gap:6}}>
          {['all','unread'].map(t => (
            <button key={t} onClick={()=>setTab(t)}
              style={{padding:"8px 16px",fontSize:13,fontWeight:600,borderRadius:999,border:"1px solid rgba(0,0,0,.08)",
                      background: tab===t ? "var(--t1)" : "transparent",
                      color: tab===t ? "#fff" : "var(--t2)",cursor:"pointer"}}>
              {t === 'all' ? `All (${inbox.length})` : `Unread (${unreadCount})`}
            </button>
          ))}
        </div>
        <input className="inp" value={query} onChange={e=>setQuery(e.target.value)}
               placeholder="Search notifications…" style={{flex:1,minWidth:220}} />
      </div>

      <div style={{display:"flex",gap:6,marginBottom:14,overflowX:"auto",paddingBottom:4}}>
        {CATEGORIES.map(c => (
          <button key={c} onClick={()=>setCat(c)}
            style={{padding:"6px 12px",fontSize:12,fontWeight:600,borderRadius:10,whiteSpace:"nowrap",
                    border:"1px solid rgba(0,0,0,.06)",
                    background: cat===c ? "rgba(59,130,246,.1)" : "rgba(255,255,255,.6)",
                    color: cat===c ? "var(--blue)" : "var(--t2)",cursor:"pointer"}}>
            {c === 'all' ? `All ${counts.all ? `(${counts.all})` : ''}` : `${TYPE_LABELS[c]} ${counts[c] ? `(${counts[c]})` : ''}`}
          </button>
        ))}
      </div>

      <div className="card-s" style={{padding:14,display:"flex",flexDirection:"column",gap:10}}>
        {rows.length === 0 && (
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"80px 20px",textAlign:"center"}}>
            <div style={{width:80,height:80,borderRadius:22,background:"rgba(100,116,139,.08)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:36,marginBottom:20}}>🔔</div>
            <div style={{fontSize:22,fontWeight:700,color:"var(--t1)",marginBottom:8,fontFamily:"var(--fd)"}}>You're all caught up</div>
            <div style={{fontSize:13.5,color:"var(--t3)",lineHeight:1.7,maxWidth:360}}>
              No notifications match your current filters.
            </div>
          </div>
        )}
        {rows.map(row => (
          <NotifRow key={row.id} row={row} userId={user?.id} navigate={navigate} />
        ))}
      </div>
    </div>
  );
});
